/* =======================================================================
   COPY.JS — Tutti i testi del sito, in italiano e inglese
   =======================================================================
   Questo file contiene OGNI testo che vedi sul sito.
   Per ogni voce trovi due lingue: { it: "...italiano...", en: "...inglese..." }
   Cambia solo il testo dentro le virgolette, NON cambiare le parole prima dei due punti
   (es. "title", "body", "sub" sono "etichette" usate dal codice).

   Sezioni (in ordine):
     - nav        → testo delle voci nel menu di navigazione in alto
     - hero       → riquadro principale della home (titolo gigante + bottoni)
     - intro      → sezione "Benvenuti" con la firma di Massimiliano
     - philosophy → 4 card colorate (Madre / Tempo / Origini / AIC)
     - doughs     → blocco "Impasti speciali" (6 voci)
     - percorsi   → (non più usato, lasciato qui per riferimento)
     - poem       → poesia "Viva la Pizza!!!"
     - visit      → indirizzo, orari, telefoni, servizi della pagina Contatti
     - footer     → testo del piè di pagina
     - story      → tutta la pagina "La Nostra Storia"
     - pages      → testi delle pagine Menù e Galleria
   ======================================================================= */

// UI translations IT / EN.
const t = {
  /* ----------- VOCI DEL MENU IN ALTO ----------- */
  nav: {
    home: { it: "Home", en: "Home" },
    story: { it: "La Nostra Storia", en: "Our Story" },
    menu: { it: "Menù", en: "Menu" },
    gallery: { it: "Galleria", en: "Gallery" },
    visit: { it: "Contatti", en: "Contact" },
  },
  /* ----------- RIQUADRO PRINCIPALE DELLA HOME (titolo + bottoni) ----------- */
  hero: {
    eyebrow: { it: "Dal 2014 · Rosignano Marittimo", en: "Since 2014 · Rosignano Marittimo" },
    title_a: { it: "Le Simpatiche", en: "Le Simpatiche" },
    title_b: { it: "Canaglie", en: "Canaglie" },
    sub: {
      it: "Pizzeria artigianale toscana. Lunghe lievitazioni, pasta madre viva, grani antichi italiani e una cucina interamente dedicata al senza glutine, certificata AIC.",
      en: "Tuscan artisan pizzeria. Long fermentations, living sourdough, Italian ancient grains and a fully gluten-free certified kitchen by AIC.",
    },
    cta_menu: { it: "Sfoglia il menù", en: "Browse the menu" },
    cta_call: { it: "Prenota · Chiama", en: "Book · Call us" },
    cta_visit: { it: "Vieni a trovarci", en: "Pay us a visit" },
  },
  /* ----------- SEZIONE BENVENUTI (con la firma di Massimiliano) ----------- */
  intro: {
    overline: { it: "Benvenuti", en: "Welcome" },
    title: {
      it: "Una pizza che si ricorda,\nche si racconta.",
      en: "A pizza you remember,\nand love to talk about.",
    },
    body: {
      it: "Da oltre dieci anni, in Via A. Gramsci 55, davanti alla Chiesa, impastiamo, lievitiamo e cuociamo con un solo obiettivo: una pizza altamente digeribile, profumata, viva. La nostra famiglia di impasti e ingredienti è una piccola dichiarazione d'amore alla tradizione e al territorio.",
      en: "For over ten years, at Via A. Gramsci 55, opposite the church, we have been kneading, proofing and baking with one goal: a highly digestible, fragrant, living pizza. Our family of doughs and ingredients is a small love letter to tradition and territory.",
    },
    signature: { it: "Massimiliano Ciaffone", en: "Massimiliano Ciaffone" },
    signature_role: { it: "Pizzaiolo · Fondatore", en: "Pizzaiolo · Founder" },
  },
  /* ----------- 4 CARD COLORATE (Madre / Tempo / Origini / AIC) ----------- */
  philosophy: {
    overline: { it: "La nostra filosofia", en: "Our philosophy" },
    title: {
      it: "Tempo, materia, calore.",
      en: "Time, matter, heat.",
    },
    cards: [
      {
        tag: { it: "Madre", en: "Mother" },
        title: { it: "Pasta Madre Viva", en: "Living Sourdough" },
        body: {
          it: "Pizze, pane, panettoni e colombe nati dalla nostra pasta madre. Un sapore inconfondibile, una qualità che si sente.",
          en: "Pizzas, breads, panettoni and colombe born from our sourdough starter. Unmistakable flavour, quality you can feel.",
        },
      },
      {
        tag: { it: "Tempo", en: "Time" },
        title: { it: "Alta Digeribilità", en: "Highly Digestible" },
        body: {
          it: "Rispettiamo i naturali tempi di lievitazione e maturazione. Mangi e ti senti leggero, anche la sera tardi.",
          en: "We respect the natural times of leavening and maturation. You eat, and feel light — even late at night.",
        },
      },
      {
        tag: { it: "Origini", en: "Origins" },
        title: { it: "Grani Antichi · 100% Italiani", en: "Ancient Grains · 100% Italian" },
        body: {
          it: "Farina di tipo 1 di grano tenero biologico selezionato e coltivato in Sicilia. Cereali e semi biologici per impasti vivi e nutrienti.",
          en: "Type 1 organic soft wheat flour, selected and grown in Sicily. Organic cereals and seeds for living, nourishing doughs.",
        },
      },
      {
        tag: { it: "AIC", en: "AIC" },
        title: { it: "Cucina Senza Glutine Dedicata", en: "Dedicated Gluten-Free Kitchen" },
        body: {
          it: "Un laboratorio interamente dedicato a pizze, dolci e antipasti senza glutine, con personale formato dall'Associazione Italiana Celiachia.",
          en: "A laboratory entirely dedicated to gluten-free pizzas, desserts and starters, staffed by personnel trained by the Italian Coeliac Association.",
        },
      },
    ],
  },
  /* ----------- BLOCCO "IMPASTI SPECIALI" (compare in Home e in fondo al Menù) ----------- */
  doughs: {
    overline: { it: "Impasti speciali", en: "Special doughs" },
    title: { it: "Sei modi di farsi ricordare.", en: "Six ways to be remembered." },
    note: {
      it: "Tutti gli impasti speciali +€ 1,50. Disponibilità variabile di serata in serata.",
      en: "All special doughs +€ 1.50. Availability varies night by night.",
    },
    list: [
      {
        name: { it: "Tonda Classica", en: "Round Classic" },
        body: { it: "Sottile e friabile, l'icona italiana.", en: "Thin and crisp, the Italian icon." },
      },
      {
        name: { it: "Integrale", en: "Wholegrain" },
        body: { it: "Altamente idratata, ricca di fibre nobili.", en: "Highly hydrated, rich in noble fibers." },
      },
      {
        name: { it: "Grani Antichi", en: "Ancient Grains" },
        body: { it: "Tipo 1 biologico siciliano, 100% italiano.", en: "Type 1 organic Sicilian, 100% Italian." },
      },
      {
        name: { it: "Ai Cereali", en: "Multigrain" },
        body: { it: "Avena, segale, frumento e semi di zucca, girasole, sesamo, miglio, lino.", en: "Oats, rye, wheat and pumpkin, sunflower, sesame, millet, flax seeds." },
      },
      {
        name: { it: "Teglia alla Romana", en: "Roman-Style Tray" },
        body: { it: "Nuvole soffici ricoperte di croccantezza.", en: "Pillowy clouds with a crisp crust." },
      },
      {
        name: { it: "Senza Glutine", en: "Gluten-Free" },
        body: { it: "Preparata con cura e attenzione, in laboratorio dedicato.", en: "Prepared with care, in a dedicated lab." },
      },
    ],
  },
  menuSection: {
    overline: { it: "Il menù", en: "The menu" },
    title: { it: "Tutto ciò che amerai stasera.", en: "Everything you'll love tonight." },
    sub: {
      it: "Materie prime selezionate, vini esclusivamente toscani, birre artigianali italiane. * = allergeni.",
      en: "Selected ingredients, exclusively Tuscan wines, Italian craft beers. * = allergens.",
    },
    allergens: { it: "Allergeni", en: "Allergens" },
    filter_all: { it: "Tutte le portate", en: "All courses" },
  },
  percorsi: {
    overline: { it: "I percorsi", en: "Tasting journeys" },
    title: { it: "Lasciati guidare al tavolo.", en: "Let us lead you at the table." },
    sub: {
      it: "Due esperienze pensate per chi vuole assaggiare di tutto, con calma.",
      en: "Two experiences for those who want to taste it all, slowly.",
    },
    convivial: {
      name: { it: "Percorso Conviviale", en: "Convivial Journey" },
      body: {
        it: "Pensato per gruppi: una varietà a sorpresa di pizze alla teglia e pizze tonde tagliate a spicchi, da condividere.",
        en: "Made for groups: a surprise variety of tray pizzas and classic round pizzas cut into slices, to share.",
      },
    },
    gusto: {
      name: { it: "Percorso nel Gusto", en: "Journey of Taste" },
      body: {
        it: "Minimo due persone. 1½ pizza tonda a scelta, 1 trancio di teglia alla romana e ¼ di pizza dessert.",
        en: "Minimum two people. 1½ round pizza of your choice, 1 Roman tray slice, ¼ dessert pizza.",
      },
    },
    note: {
      it: "Il prezzo varia in base alle pizze scelte. Le singole pizze hanno +€ 2 per la farcitura maggiore.",
      en: "Price varies based on chosen pizzas. Individual pizzas +€ 2 for richer toppings.",
    },
  },
  /* ----------- POESIA "VIVA LA PIZZA!!!" (sfondo terracotta) ----------- */
  poem: {
    title: { it: "Viva la Pizza!!!", en: "Viva la Pizza!!!" },
    lines: {
      it: [
        "Gusta la pizza, pacifica nemica della fame!",
        "Gioiosa taglia la colorata delizia",
        "E addenta la saporita morbidezza!",
        "",
        "Affonda in lei i tuoi occhi e la tua bocca",
        "E in te rinasce il fanciullo saggio",
        "Che tutto afferra, assaggia, vuol provare!",
        "",
        "Pizza: che festa sei tu per le famiglie,",
        "Che simpatiche occasioni per gli amici",
        "Di ogni età, d'ogni generazione.",
        "",
        "Pizza, tu sei l'invito a un grande girotondo,",
        "con te sorride l'universo mondo!",
      ],
      en: [
        "Taste the pizza, peaceful enemy of hunger!",
        "Joyfully cut the colourful delight",
        "And bite into its tasty softness!",
        "",
        "Sink your eyes and mouth into it",
        "And the wise child is reborn in you",
        "Who grasps, tastes, wants to try everything!",
        "",
        "Pizza: what a feast you are for families,",
        "What charming occasions for friends",
        "Of every age, of every generation.",
        "",
        "Pizza, you are the invitation to a great round-dance,",
        "with you the whole world smiles!",
      ],
    },
  },
  /* ----------- PAGINA CONTATTI (indirizzo, orari, telefoni) -----------
     Modifica qui:
       • address: cambia l'indirizzo se ti sposti
       • hours_rows: cambia gli orari (giorno per giorno)
       • phones: aggiungi/rimuovi numeri (chiamabili al click) */
  visit: {
    overline: { it: "Contatti", en: "Contact" },
    title: { it: "Vieni a trovarci.", en: "Come and find us." },
    address_label: { it: "Indirizzo", en: "Address" },
    address: { it: "Via A. Gramsci 55\n57016 Rosignano Marittimo (LI)\nToscana, Italia", en: "Via A. Gramsci 55\n57016 Rosignano Marittimo (LI)\nTuscany, Italy" },
    hours_label: { it: "Orari di apertura", en: "Opening hours" },
    hours_rows: [
      { day: { it: "Mercoledì", en: "Wednesday" }, time: "18:00 – 23:30" },
      { day: { it: "Giovedì", en: "Thursday" }, time: "18:00 – 23:30" },
      { day: { it: "Venerdì", en: "Friday" }, time: "18:00 – 23:30" },
      { day: { it: "Sabato", en: "Saturday" }, time: "18:00 – 22:30" },
      { day: { it: "Domenica", en: "Sunday" }, time: "18:30 – 22:30" },
      { day: { it: "Lunedì", en: "Monday" }, time: { it: "Chiuso", en: "Closed" }, closed: true },
      { day: { it: "Martedì", en: "Tuesday" }, time: { it: "Chiuso", en: "Closed" }, closed: true },
    ],
    contact_label: { it: "Chiamaci", en: "Call us" },
    phones: [
      { label: { it: "Cellulare", en: "Mobile" }, number: "347 381 3901" },
      { label: { it: "Fisso", en: "Landline" }, number: "0586 790 139" },
    ],
    services_label: { it: "Servizi", en: "Services" },
    services: {
      it: "Asporto · Taglio · Pizza in teglia · Cucina senza glutine certificata AIC · Coperto € 2,00",
      en: "Take-away · By the slice · Roman tray · AIC-certified gluten-free kitchen · Cover € 2.00",
    },
    cta_directions: { it: "Apri in Mappe", en: "Open in Maps" },
  },
  /* ----------- TESTO DEL FOOTER (piè di pagina) ----------- */
  footer: {
    rights: { it: "Tutti i diritti riservati.", en: "All rights reserved." },
    sign: { it: "Una piacevole e gustosa serata vi attende.", en: "A pleasant and tasty evening awaits you." },
  },
  /* ----------- PAGINA "LA NOSTRA STORIA" -----------
     Sezioni:
       • eyebrow/title/lead → testo iniziale
       • chapters → la linea del tempo (per aggiungere un anno, copia un blocco { year, title, body })
       • pull_quote → la grande citazione su sfondo rosso
       • press → titolo e sottotitolo della "Rassegna stampa" (le voci stanno in press.js) */
  story: {
    eyebrow: { it: "La nostra storia", en: "Our story" },
    title: {
      it: "Una passione personale\ndiventata professione.",
      en: "A personal passion\nthat became a profession.",
    },
    lead: {
      it: "Tutto nasce da una passione personale che mano a mano nel corso degli anni si è tramutata in professione. Dal 2009 Massimiliano inizia con grande entusiasmo a muoversi nell'ambito della pizza di alto livello — fiere, gare mondiali, eventi internazionali — fino al 2014, quando apre ufficialmente Le Simpatiche Canaglie.",
      en: "It all begins from a personal passion that gradually became a profession over the years. Since 2009 Massimiliano begins moving in the world of top-tier pizza — fairs, world championships, international events — until 2014, when Le Simpatiche Canaglie officially opens.",
    },
    chapters: [
      {
        year: "2009",
        title: { it: "Inizia il viaggio", en: "The journey begins" },
        body: {
          it: "Con grande entusiasmo Massimiliano inizia a muoversi nell'ambito della pizza di alto livello, frequentando professionisti del settore in giro per l'Italia.",
          en: "With great enthusiasm, Massimiliano begins moving in the world of top-tier pizza, working alongside industry professionals across Italy.",
        },
      },
      {
        year: "2011",
        title: { it: "Rimini e l'Università della Pizza", en: "Rimini and Pizza University" },
        body: {
          it: "Approdo a Rimini: partecipazioni ad eventi internazionali, fiere, corsi professionalizzanti, successi nelle Gare Mondiali e formazione in locali della riviera romagnola. Queste esperienze diventano la base del bagaglio professionale, culminando nell'Università della Pizza.",
          en: "Landing in Rimini: international events, fairs, professional courses, successes at the World Championships and training in venues along the Romagna coast. These experiences become the backbone of the craft, culminating at Pizza University.",
        },
      },
      {
        year: "2014",
        title: { it: "Nasce Le Simpatiche Canaglie", en: "Le Simpatiche Canaglie is born" },
        body: {
          it: "La svolta: ufficialmente inizia l'avventura de Le Simpatiche Canaglie. Una pizza contemporanea che mantiene la tradizione e valorizza i prodotti del territorio. Tempi giusti di maturazione e lievitazione, materie prime selezionate, tecnica curata. Tutti i dolci della casa sono preparati interamente senza glutine; durante le feste arrivano colombe, panettoni e pandori a pasta madre. Poi la consacrazione: il locale diventa Petra Partner.",
          en: "The turning point: Le Simpatiche Canaglie officially begins. A contemporary pizza that honours tradition and the products of the territory. Proper maturation and proofing times, selected ingredients, careful technique. All house desserts are entirely gluten-free; during the holidays, sourdough colombe, panettoni and pandori arrive. Then the consecration: the restaurant becomes a Petra Partner.",
        },
      },
      {
        year: "2017 → 2022",
        title: { it: "Eventi e palcoscenici", en: "Events and stages" },
        body: {
          it: "Lucca Summer Festival 2017: pizze per la sala stampa e i VIP. A casa, quattro serate \"A Cena con Pinocchio\" insieme ad Andrea Balestri. Per i 500 anni dalla morte di Leonardo da Vinci, una serata dedicata insieme a Elvezio Montesarchio. Partecipazione alla trasmissione \"Mica Pizza e Fichi\" su La7.",
          en: "Lucca Summer Festival 2017: pizzas for the press room and VIPs. At home, four \"Dinner with Pinocchio\" nights with Andrea Balestri. For the 500th anniversary of Leonardo da Vinci's death, a dedicated evening with Elvezio Montesarchio. Featured on the La7 show \"Mica Pizza e Fichi\".",
        },
      },
      {
        year: "2023 → 2024",
        title: { it: "Pizza & Peace · solidarietà", en: "Pizza & Peace · solidarity" },
        body: {
          it: "Con l'associazione Pizza & Peace, due grandi eventi di beneficenza: nel 2023 \"Pizza per l'Emilia Romagna\" e nel 2024 una serata di raccolta fondi per gli alluvionati di Quarrata. Il forno acceso anche per gli altri.",
          en: "With the Pizza & Peace association, two major charity events: in 2023 \"Pizza for Emilia Romagna\" and in 2024 a fundraising night for the Quarrata flood victims. The oven lit for others too.",
        },
      },
    ],
    pull_quote: {
      it: "«Una pizza contemporanea che racconta la tradizione e il territorio.»",
      en: "“A contemporary pizza that tells the story of tradition and territory.”",
    },
    pull_quote_attr: { it: "Massimiliano Ciaffone", en: "Massimiliano Ciaffone" },
    values_title: { it: "Ciò che non cambia mai.", en: "What never changes." },
    values: [],
    cta_label: { it: "Scopri il menù", en: "Discover the menu" },
    press: {
      eyebrow: { it: "Rassegna stampa", en: "Press · Media" },
      title: {
        it: "Articoli, eventi e\nappuntamenti.",
        en: "Articles, events and\nappearances.",
      },
      sub: {
        it: "Massimiliano racconta la sua pizza dai grandi palcoscenici italiani — TV, riviste di settore, fiere e festival.",
        en: "Massimiliano takes his pizza to the Italian stage — TV, trade magazines, fairs and festivals.",
      },
    },
  },
  /* ----------- TESTI DELLE PAGINE MENÙ E GALLERIA ----------- */
  pages: {
    menu: {
      eyebrow: { it: "Il menù", en: "The menu" },
      title: { it: "Tutto ciò che amerai stasera.", en: "Everything you'll love tonight." },
      sub: {
        it: "Materie prime selezionate, vini esclusivamente toscani, birre artigianali italiane. * = allergeni.",
        en: "Selected ingredients, exclusively Tuscan wines, Italian craft beers. * = allergens.",
      },
    },
    visit: {
      eyebrow: { it: "Visitaci", en: "Visit us" },
      title: {
        it: "Davanti alla Chiesa,\ndal pomeriggio a tarda notte.",
        en: "Across from the church,\nfrom afternoon to late night.",
      },
    },
    gallery: {
      eyebrow: { it: "Galleria", en: "Gallery" },
      title: {
        it: "Le serate, gli impasti,\nle nostre pizze.",
        en: "Evenings, doughs,\nour pizzas.",
      },
      sub: {
        it: "Un piccolo album di immagini dal nostro locale di Rosignano Marittimo. Clicca su una foto per ingrandirla.",
        en: "A small album from our place in Rosignano Marittimo. Click any photo to enlarge it.",
      },
      filter_all: { it: "Tutte", en: "All" },
      filters: {
        pizze: { it: "Pizze", en: "Pizzas" },
        locale: { it: "Locale", en: "The place" },
        impasti: { it: "Impasti", en: "Doughs" },
        eventi: { it: "Eventi", en: "Events" },
      },
      empty: { it: "Nessuna foto in questa categoria.", en: "No photos in this category." },
    },
  },
};

export default t;
